// Most of these are according to this table: http://www.ssicom.org/js/x171166.htm
// However where nodejs readline diverges, they are adjusted to conform to it
module.exports = {
  nomod: {
      escape: '\u001b'
    , space: ' ' // actually '\u0020'
    }
  , ctrl: {
        ' ': '\u0000'
      , 'a': '\u0001'
      , 'b': '\u0002'
      , 'c': '\u0003'
      , 'd': '\u0004'
      , 'e': '\u0005'
      , 'f': '\u0006'
      , 'g': '\u0007'
      , 'h': '\u0008'
      , 'i': '\u0009'
      , 'j': '\u000a'
      , 'k': '\u000b'
      , 'm': '\u000c'
      , 'n': '\u000d'
      , 'l': '\u000e'
      , 'o': '\u000f'
      , 'p': '\u0010'
      , 'q': '\u0011'
      , 'r': '\u0012'
      , 's': '\u0013'
      , 't': '\u0014'
      , 'u': '\u0015'
      , 'v': '\u0016'
      , 'w': '\u0017'
      , 'x': '\u0018'
      , 'y': '\u0019'
      , 'z': '\u001a'
      , '[': '\u001b'
      , '\\':'\u001c'
      , ']': '\u001d'
      , '^': '\u001e'
      , '_': '\u001f'

      , 'space': '\u0000'
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/parse-key/keycodes.js
// module id = 2879
// module chunks = 0